import { Map as ImmutableMap } from 'immutable'
import { connect } from 'react-redux'

import { getBasketOrderId } from 'selectors/basket'
import { getUserOrders } from 'selectors/user'
import { getUserOrderById } from 'utils/user'

import { YourFirstBox } from './YourFirstBox'

const mapStateToProps = (state: any) => {
  const { user } = state
  const orderId = getBasketOrderId(state)
  const userOrders = getUserOrders({ user })
  const order = getUserOrderById(orderId!, userOrders)

  const prices = order.get('prices', ImmutableMap())
  const deliveryDate = order.get('deliveryDate')
  const cutOffDate = order.get('shouldCutoffAt')
  const percentageOff = prices.get('percentageOff')

  return {
    deliveryDate,
    cutOffDate,
    percentageOff,
  }
}

const YourFirstBoxContainer = connect(mapStateToProps)(YourFirstBox)
export { YourFirstBoxContainer }
